export default "__VITE_ASSET__0SyKCWTJ__"